/**
 * Репозиторий сущности «Отметка привычки».
 * CRUD, мягкое удаление и запись в очередь синхронизации — в базовой фабрике
 * (`src/shared/db/repository.ts`). Здесь только специфичные запросы.
 */

import { db } from '@/shared/db/database';
import { createRepository } from '@/shared/db/repository';
import type { HabitEntry } from '@/shared/db/schema';

export const habitEntriesRepo = createRepository<HabitEntry>('habitEntries', db.habitEntries);
